import { Grid, Typography } from '@material-ui/core';
import { Page, Header, Content, ContentHeader } from '@backstage/core-components';
import { GitHubProfileCard } from './GitHubProfileCard';

export const GitHubProfilePage = () => {
  return (
    <Page themeId="home">
      <Header title="GitHub Profile" />
      <Content>
        <ContentHeader title="GitHub Organizations">
          <Typography variant="body1">
            View your GitHub organization memberships and profile information
          </Typography>
        </ContentHeader>
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12} md={8}>
            <GitHubProfileCard />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};